import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(styles);



export default function ExemptPageInside(props) {
    
    const classes = useStyles();
    const { t } = useTranslation();

    return(
        <div>
        <Parallax small image={require("assets/img/principal.jpg")} />
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <form className={classes.form} style={{borderRadius: "8px"}}>
                    <CardHeader>
                        <div style={{width: "20px"}}></div>
                    </CardHeader>
                    <CardBody>
                        <GridContainer  justify = "center">
                            <GridItem xs={11} sm={11} md={11}>
                                {
                                <div>
                                    <img src={require('assets/img/check.png')} alt= {"check"} style={{maxWidth: "100px", width: "100%", display: "block",  marginLeft: "auto",  marginRight: "auto"}} />
                                    <h2 className={classes.defaultFont} style={{textAlign: "center"}}>{t("ExemptText")}</h2>
                                </div>
                                }
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </form>
            </GridItem>
        </GridContainer>
        </div>
    );
}